import { useBrandingStore } from '../store/branding.store';

/**
 * Logo (marca oficial + nome do produto) — compartilhado entre Login, Register,
 * recuperação de senha, etc. Lê `app_nome` do `useBrandingStore` (carregado
 * via GET /system-settings/public no boot do App). Fallback vem do próprio
 * store quando o backend está fora (AB#61 bug 2).
 *
 * A marca é `public/logo.svg` — o SVG já traz o fundo teal e o canto arredondado
 * (`rx` no próprio arquivo), então a `<img>` não precisa de wrapper nem de
 * `rounded-*`. Fica `aria-hidden` com `alt=""` porque é decorativa: o nome do
 * produto já é lido do `<span>` ao lado.
 */
export function AuthLogo() {
  const appNome = useBrandingStore((s) => s.app_nome);
  return (
    <div className="flex items-center gap-2.5">
      <img src="/logo.svg" alt="" className="h-[34px] w-[34px] shrink-0" aria-hidden="true" />
      <span className="text-[17px] font-bold tracking-tight text-text-primary">{appNome}</span>
    </div>
  );
}
